// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1LYve","requiredAsterisk":"Info_requiredAsterisk__3ws1j"};